import React, { useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import styles from "../../styles/shap_of_you.module.scss";
import img1 from "../../assets/images/shap-img1.png";
import img2 from "../../assets/images/shap-img2.png";
import { MobileNavigationProps } from "./types";

const WalkthroughScreen: React.FC<MobileNavigationProps> = ({
  navigateToStep,
  isAuthenticated,
}) => {
  const [loading, setLoading] = useState(false);

  // Handle "Get Started" button click with consent checking
  const handleGetStarted = async () => {
    setLoading(true);

    try {
      if (isAuthenticated) {
        // User is authenticated - check consent status via API
        const { data } = await httpClient.get(endpoints.auth.getConsentForm());

        if (data.statusText === "accepted") {
          // Scenario 1: Consent already accepted - skip TC, go to welcome
          console.log("Consent already accepted, skipping TC screen");
          navigateToStep("welcome");
        } else {
          // Scenario 2: Consent rejected - show TC screen
          navigateToStep("tc");
        }
      } else {
        // Scenario 3: User is NOT authenticated - go to TC without API call
        navigateToStep("tc");
      }
    } catch (error) {
      console.error("Error checking consent status:", error);
      // If API fails, show TC screen anyway
      navigateToStep("tc");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-md-none w-100">
      <div className={styles.wrapper_slider}>
        <Swiper
          spaceBetween={0}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className={styles.swiperSlide}>
              <div className={styles.slide}>
                <Image
                  className={styles.bgImage}
                  src={img1}
                  alt="Scan Your Face"
                />

                <div className={styles.overlay_n}>
                  <h2>Scan Your Face</h2>
                  <p>Upload or take a photo of your face</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.swiperSlide}>
              <div className={styles.slide}>
                <Image
                  className={styles.bgImage}
                  src={img2}
                  alt="Live Analysis"
                />

                <div className={styles.overlay_n}>
                  <h2>Live Analysis</h2>
                  <p>Get instant analysis of your face type</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.swiperSlide}>
              <div className={styles.banner1}>
                <Image className={styles.bgImage} src={img1} alt="" />
                <div className={styles.overlay_n}>
                  <h2>The Shape of You</h2>
                  <p>
                    Discover your face shape and shop jewellery made for you.
                  </p>

                  <button
                    className={styles.primaryBtn}
                    onClick={handleGetStarted}
                    disabled={loading}
                    style={
                      loading
                        ? {
                            background: "#d3d3d3",
                            color: "#888",
                            cursor: "not-allowed",
                            opacity: 0.6,
                          }
                        : {}
                    }
                  >
                    {loading ? "Loading..." : "Get Started"}
                  </button>
                  <button
                    className={styles.secondaryBtn}
                    onClick={() => navigateToStep("about")}
                  >
                    Know More
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default WalkthroughScreen;
